import { makeAutoObservable } from 'mobx';
import apiConfig from '../api/routes';
import { LeaveTemplatesType, LocaleAttachmentsType, LocaleTemplateType } from '../types';
class Help {
  constructor() {
    makeAutoObservable(this);
  }

  availableAttachments: LocaleAttachmentsType | null = null;
  availableTemplates: LocaleTemplateType | null = null;
  availableTemplatesForUser: LeaveTemplatesType | null = null;

  fetchAvailableAttachments = async (countryName: string) => {
    this.availableAttachments = await apiConfig.helpService.getAvailableAttachments(countryName);
  };

  fetchAvailableTemplates = async (countryName: string) => {
    this.availableTemplates = await apiConfig.helpService.getAvailableTemplates(countryName);
  };

  fetchAvailableTemplatesForUser = async (userId: number) => {
    this.availableTemplatesForUser = await apiConfig.helpService.getAvailableTemplatesForUser(userId);
  };

  downloadFile = async (ref: string) => {
    return await apiConfig.helpService.getDownloadFile(ref);
  };

}

export const HelpStore = new Help();
